
<template>
<div>
  <chc-header :noLogin="true"></chc-header>
  <navbar :noLogin="true"></navbar>
  <section>
    <div class="col">
      <h1>404 Not Found</h1>
    </div>
  </section>
</div>
</template>

<script>
import ChcHeader from '@/components/ChcHeader'
import Navbar from '@/components/Navbar'

export default {
  name: 'Login',
  data () {
    return {
    }
  },
  components: {
    ChcHeader,
    Navbar
  }
}
</script>

<style scoped>
h1 {
    margin-top: 4em;
    text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue